import { DefaultTheme } from "styled-components";

export const LightTheme: DefaultTheme = {
  colors: {
    pageBackground: "#FBFCFD",
    cardBackground: "#FFFFFF",

    primary: "#452CDC",
    links: "#2F80ED",
    spinner: "#404040",
    header: "#000000",
    userBio: "#828282",
    stargazersCount: "#5a5a5a",

    textWhite: "#FFFFFF",
  },

  spacing: 8,

  search: {
    bgColor: "#F0F3F4",
    placeholderColor: "#9E9E9E",
    color: "#4F4F4F",
  },
};
